import { PropertyService } from '../services/property.service';
import {NgModule} from '@angular/core';
import {CommonModule} from '@angular/common';
import {FlexLayoutModule} from '@angular/flex-layout';
import {MatIconModule} from '@angular/material/icon';
import {MatButtonModule} from '@angular/material/button';
import {MatInputModule} from '@angular/material/input';
import {MatCheckboxModule} from '@angular/material/checkbox';
import {MatTabsModule} from '@angular/material/tabs';
import {MatTableModule} from '@angular/material/table';
import {ColorPickerModule} from 'ngx-color-picker';
import {FormsModule, ReactiveFormsModule} from '@angular/forms';
import {MatDividerModule} from '@angular/material/divider';
import {MatFormFieldModule} from '@angular/material/form-field';
import {MatSelectModule} from '@angular/material/select';
import {MatAutocompleteModule} from '@angular/material/autocomplete';
import {MatDatepickerModule} from '@angular/material/datepicker';
import {MatSlideToggleModule} from '@angular/material/slide-toggle';
import { CustomTooltipModule } from '../directives/tooltip-directive.module';
import {CreatePropertiesComponent} from './create-properties.component';
import {AutoFocusModule} from '../auto-focus/auto-focus.module';
import { TranslateModule } from '@ngx-translate/core';


@NgModule({
    declarations: [CreatePropertiesComponent],
    imports: [
        CommonModule,
        ColorPickerModule,
        MatFormFieldModule,
        MatSelectModule,
        MatAutocompleteModule,
        MatIconModule,
        MatButtonModule,
        MatInputModule,
        MatCheckboxModule,
        MatTableModule,
        MatDatepickerModule,
        FlexLayoutModule,
        MatTabsModule,
        MatSlideToggleModule,
        FormsModule,
        ReactiveFormsModule,
        MatDividerModule,
        AutoFocusModule,
        CustomTooltipModule,
        TranslateModule // translate module

    ],
    exports: [
        CreatePropertiesComponent,
    ],
    providers: [PropertyService]
})
export class CreatePropertiesModule {
}
